import React from 'react';

interface Props {
  text: string;
  status: string;
}

const getStatusClassName = (status: string) => status.toLowerCase().replace(/_/g, '-');

const MissionStatus: React.FC<Props> = ({ text, status }) => (
  <div className={`badge-base mission-status mission-status--${getStatusClassName(status)}`}>
    <div className="badge-text">
      <span>{text}</span>
    </div>
  </div>
);

export default MissionStatus;
